import React from 'react';

import { Alert, AlertProps } from 'react-bootstrap';

export enum AlertVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Dark = 'dark',
  Light = 'light',
}

interface IPohAlertProps extends AlertProps {
  variant?: AlertVariant;
  dismissible?: boolean;
}

const PohAlert: React.FC<IPohAlertProps> = ({
  children,
  variant = AlertVariant.Info,
  dismissible = false,
  ...props
}) => (
  <Alert dismissible={dismissible} variant={variant} {...props}>
    {children}
  </Alert>
);

export default PohAlert;
